import { appointmentDraftSelectors } from './appointment-draft.selectors';

export const buildCreateAppointmentRequest = (state) => {
  const selectedSlot = appointmentDraftSelectors.selectAppointmentTimeSlot(state);
  const selectedAddress = appointmentDraftSelectors.selectDraftAddress(state);

  const relatedAppointments = appointmentDraftSelectors
    .selectRelatedAppointmentDrafts(state)
    .map((relatedAppointmentDraft) => ({
      appointmentTypeId: relatedAppointmentDraft.appointmentType.id,
      slot: {
        date: relatedAppointmentDraft.dateSlot,
        time: relatedAppointmentDraft.timeSlot.from,
        eventId: relatedAppointmentDraft.timeSlot.eventId,
      },
    }));

  return {
    appointmentTypeId: appointmentDraftSelectors.selectAppointmentTypeId(state),
    partnerId: appointmentDraftSelectors.selectPartnerId(state),
    partnersGroupId: appointmentDraftSelectors.selectPartnersGroupId(state),
    storeId: appointmentDraftSelectors.selectShop(state).id,
    slot: {
      date: appointmentDraftSelectors.selectAppointmentDateSlot(state),
      time: selectedSlot.from,
      eventId: selectedSlot.eventId,
    },
    address: selectedAddress,
    relatedAppointments,
    products: appointmentDraftSelectors
      .selectProducts(state)
      .map(({ id, selectionType, quantity, information }) => ({
        id,
        selectionTypeId: selectionType ? selectionType.id : null,
        quantity,
        information,
      })),
  };
};
